import type { ConfigurationCriteriaProductsSlice } from 'src/store/configurationCriteriaProductsSlice';
import { createConfigurationCriteriaProductsSlice } from 'src/store/configurationCriteriaProductsSlice';
import type { ForecastSessionSlice } from 'src/store/forecastSessionSlice';
import { forecastSessionSlice } from 'src/store/forecastSessionSlice';
import type { ForecastSlice } from 'src/store/forecastSlice';
import { forecastSlice } from 'src/store/forecastSlice';
import type { LoadingSlice } from 'src/store/loadingSlice';
import { loadingSlice } from 'src/store/loadingSlice';
import type { PreferencesSlice } from 'src/store/preferencesSlice';
import { preferencesSlice } from 'src/store/preferencesSlice';
import type { ToolbarSlice } from 'src/store/toolbarSlice';
import { toolbarSlice } from 'src/store/toolbarSlice';
import { create } from 'zustand';

export const useBoundStore = create<
  LoadingSlice &
    ToolbarSlice &
    PreferencesSlice &
    ForecastSlice &
    ForecastSessionSlice &
    ConfigurationCriteriaProductsSlice
>((...a) => ({
  ...preferencesSlice(...a),
  ...loadingSlice(...a),
  ...toolbarSlice(...a),
  ...forecastSlice(...a),
  ...forecastSessionSlice(...a),
  ...createConfigurationCriteriaProductsSlice(...a),
}));
